import { DefinedTime } from '../types'

export const getMinuteTotal = (time: DefinedTime): number => {
  return time.hour * 60 + time.minute
}
